// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectDataPage_wrapper__cI3GD","newWrapper":"ProjectDataPage_newWrapper__fL3lK"};